import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface CBQExamDTO {
  id: string;
  title: string | null;
  description: string | null;
  mode: string;
  section1PassThreshold: number;
  status: string;
  publishedAt: string | null;
  publishedById: string | null;
  version: number;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

type InitCBQExamResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: CBQExamDTO;
};

export const InitCBQExam = async (): Promise<InitCBQExamResponse> => {
  try {
    const response = await axios.post(`/admin/cbq/exams/init`);
    // Endpoint wraps payload as { message, data: {...exam} }
    return { data: response.data?.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
